// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-og {
    align-items: center;
    border-radius: 8px;
    display: inline-flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    opacity: 0.5;
    position: relative;
    border: 2px solid transparent;
    height: 70px;
    width: 70px;
    text-decoration: none;
    transition: width 0.5s ease-in-out;
  }

  .link-og.active,
  .logout.active {
    background-color: #28286b;
    border-radius: 10px;
    border: 2px solid #5a5ae1; /* Adjust the color to your preference */
    opacity: 1;
    transition: width 0.5s ease-in-out;
  }

  .link-og.active .icon,
  .logout.active .icon-instance-node {
    color: #f4f4ff; /* Adjust the color to your preference */
    opacity: 1;
    transition: width 0.5s ease-in-out;
  }
  
  .link-og.active .text-wrapper,
  .logout.active .text-wrapper {
    color: #f4f4ff; /* Adjust the color to your preference */
    opacity: 1;
    transition: width 0.5s ease-in-out;
  }
  
  .QUANT-VIZ-LOGO {
    height: 50px;
    position: relative;
    width: 86px;
  }
  .divider {
    align-self: stretch;
    background-color: rgb(97, 97, 97);
    border-radius: 2px;
    height: 2px;
    position: relative;
    width: 100%;
  }

  .navigation {
    align-items: center;
    display: inline-flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 20px;
    position: relative;
  }

  .link-og:hover {
    
    background-color: rgb(40, 40, 107);
    border: 2px solid rgb(64, 64, 242);
  }
   .frame {
    align-items: center;
    display: flex;
    flex-direction: column;
    /* flex: 0 0 auto; */
    height:90%;
    flex-direction: column;
    gap: 10%;
    justify-content: space-between;
    position: relative;
  }
  
  .icon {
    color: rgb(131, 132, 150);
    width: 1.5rem;
    height: auto;
    
  }
  
  .analytics {
    width: 1.5rem;
    stroke-width: 1px;
  }
  
  .leftnav-main {
    align-items: flex-start ;
    background-color: #0D0D30 ;
    border-radius: 0px 12px 12px 0px ;
    display: inline-flex ;
    flex-direction: column; 
    width:100%;
    height: 100%;
    align-items: center;
    justify-content:space-between;
    padding: 24px ;
    position: relative ;
    font-family:PlusJakartaSans;
  }
  
  /* Additional CSS to center the text and image inside .link-og */
  .text-wrapper {
    color: rgb(245, 245, 245);
    font-family:PlusJakartaSans;
    font-size: 10px;
    font-style: var(--paragraph-2-medium-font-style);
    font-weight: var(--paragraph-2-medium-font-weight);
    letter-spacing: var(--paragraph-2-medium-letter-spacing);
    line-height: var(--paragraph-2-medium-line-height);
    position: relative;
    text-align: center;
    width: -moz-fit-content;
    width: fit-content; 
    border-bottom: 1px solid transparent;
     }
   body .link .text-wrapper {
    text-decoration: none !important;
  }
  .icon-instance-node {
    display: block;
    margin: 0 auto;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/LeftNav/LeftNav.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA;;IAEE,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB,EAAE,wCAAwC;IACnE,UAAU;IACV,kCAAkC;EACpC;;EAEA;;IAEE,cAAc,EAAE,wCAAwC;IACxD,UAAU;IACV,kCAAkC;EACpC;;EAEA;;IAEE,cAAc,EAAE,wCAAwC;IACxD,UAAU;IACV,kCAAkC;EACpC;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;;IAEE,kCAAkC;IAClC,kCAAkC;EACpC;GACC;IACC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;IACV,sBAAsB;IACtB,QAAQ;IACR,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,YAAY;;EAEd;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,iCAAiC;IACjC,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;IACd,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA,gEAAgE;EAChE;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,eAAe;IACf,gDAAgD;IAChD,kDAAkD;IAClD,wDAAwD;IACxD,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,oCAAoC;KACnC;GACF;IACC,gCAAgC;EAClC;EACA;IACE,cAAc;IACd,cAAc;EAChB","sourcesContent":[".link-og {\r\n    align-items: center;\r\n    border-radius: 8px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    justify-content: center;\r\n    opacity: 0.5;\r\n    position: relative;\r\n    border: 2px solid transparent;\r\n    height: 70px;\r\n    width: 70px;\r\n    text-decoration: none;\r\n    transition: width 0.5s ease-in-out;\r\n  }\r\n\r\n  .link-og.active,\r\n  .logout.active {\r\n    background-color: #28286b;\r\n    border-radius: 10px;\r\n    border: 2px solid #5a5ae1; /* Adjust the color to your preference */\r\n    opacity: 1;\r\n    transition: width 0.5s ease-in-out;\r\n  }\r\n\r\n  .link-og.active .icon,\r\n  .logout.active .icon-instance-node {\r\n    color: #f4f4ff; /* Adjust the color to your preference */\r\n    opacity: 1;\r\n    transition: width 0.5s ease-in-out;\r\n  }\r\n  \r\n  .link-og.active .text-wrapper,\r\n  .logout.active .text-wrapper {\r\n    color: #f4f4ff; /* Adjust the color to your preference */\r\n    opacity: 1;\r\n    transition: width 0.5s ease-in-out;\r\n  }\r\n  \r\n  .QUANT-VIZ-LOGO {\r\n    height: 50px;\r\n    position: relative;\r\n    width: 86px;\r\n  }\r\n  .divider {\r\n    align-self: stretch;\r\n    background-color: rgb(97, 97, 97);\r\n    border-radius: 2px;\r\n    height: 2px;\r\n    position: relative;\r\n    width: 100%;\r\n  }\r\n\r\n  .navigation {\r\n    align-items: center;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    position: relative;\r\n  }\r\n\r\n  .link-og:hover {\r\n    \r\n    background-color: rgb(40, 40, 107);\r\n    border: 2px solid rgb(64, 64, 242);\r\n  }\r\n   .frame {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* flex: 0 0 auto; */\r\n    height:90%;\r\n    flex-direction: column;\r\n    gap: 10%;\r\n    justify-content: space-between;\r\n    position: relative;\r\n  }\r\n  \r\n  .icon {\r\n    color: rgb(131, 132, 150);\r\n    width: 1.5rem;\r\n    height: auto;\r\n    \r\n  }\r\n  \r\n  .analytics {\r\n    width: 1.5rem;\r\n    stroke-width: 1px;\r\n  }\r\n  \r\n  .leftnav-main {\r\n    align-items: flex-start ;\r\n    background-color: #0D0D30 ;\r\n    border-radius: 0px 12px 12px 0px ;\r\n    display: inline-flex ;\r\n    flex-direction: column; \r\n    width:100%;\r\n    height: 100%;\r\n    align-items: center;\r\n    justify-content:space-between;\r\n    padding: 24px ;\r\n    position: relative ;\r\n    font-family:PlusJakartaSans;\r\n  }\r\n  \r\n  /* Additional CSS to center the text and image inside .link-og */\r\n  .text-wrapper {\r\n    color: rgb(245, 245, 245);\r\n    font-family:PlusJakartaSans;\r\n    font-size: 10px;\r\n    font-style: var(--paragraph-2-medium-font-style);\r\n    font-weight: var(--paragraph-2-medium-font-weight);\r\n    letter-spacing: var(--paragraph-2-medium-letter-spacing);\r\n    line-height: var(--paragraph-2-medium-line-height);\r\n    position: relative;\r\n    text-align: center;\r\n    width: fit-content; \r\n    border-bottom: 1px solid transparent;\r\n     }\r\n   body .link .text-wrapper {\r\n    text-decoration: none !important;\r\n  }\r\n  .icon-instance-node {\r\n    display: block;\r\n    margin: 0 auto;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
